import React from 'react';
import useAllWorkshopEvents from 'hooks/useAllWorkshopEvents';
import WorkshopEvent from 'components/UpcomingWorkshopEvents/WorkshopEvent';

const UpcomingWorkshopEvents = ({}) => {
  const events = useAllWorkshopEvents();

  return (
    <>
      {events?.map(event => {
        return <WorkshopEvent {...event} />;
      })}
    </>
  );
};

export default UpcomingWorkshopEvents;
